import {TweenMax} from 'gsap';
import {mapState} from 'vuex';
const Rellax = require('rellax');
const SizesUtils = require('../../../../viscomjs/utils/SizesUtils');

const ComponentLoad = require('../../load/ComponentLoad');
const elementsTracking = require('../../../../viscomjs/analytics/elementsTracking');

export default {
    name: 'dynasty-story',
    props: {
        id: String,
        data: Object,
        nextData: Object,
        next: String
    },
    data() {
        return {
            loaded: false,
            content: null,
            error: null
        };
    },
    computed: {
        ...mapState('menu', {
            visibility: state => !state.open
        })
    } /* ,
    watch: {
        visibility(to, from) {
            console.log('animate visibility from', from, 'to', to);
        }
    }*/,
    template: require('../../../../../../templates/dynasty-story.pug'),
    beforeRouteEnter(to, from, next) {
        // TODO: add global progress view
        ComponentLoad(to.params.id).then(
            tagName => {
                if (!tagName) {
                    next(vm => {
                        vm.setError('Fail to load content');
                    });
                    return;
                }
                next(vm => {
                    vm.destroyInner();
                    vm.setContent(tagName);
                    TweenMax.delayedCall(0.01, vm.startInner, [], vm);
                });
            },
            err => {
                next(vm => {
                    vm.setError(err);
                });
            }
        );
    },
    beforeRouteUpdate(to, from, next) {
        this.loaded = false;
        this.content = null;
        this.error = null;
        ComponentLoad(to.params.id).then(
            tagName => {
                if (!tagName) this.setError('Fail to load content');
                else {
                    this.destroyInner();
                    this.setContent(tagName);
                    TweenMax.delayedCall(0.01, this.startInner, [], this);
                }

                TweenMax.delayedCall(0.5, next);
            },
            err => {
                this.setError(err);
                next();
            }
        );
    },
    beforeRouteLeave(to, from, next) {
        this.destroyInner();
        next();
    },
    methods: {
        setContent(tagName) {
            this.loaded = true;
            this.content = tagName;
        },
        setError(err) {
            this.content = null;
            this.error = err.toString();
        },
        startInner() {
            this.startLazyimages();
            this.initRellax();
            this.startAnalytics();
        },
        destroyInner() {
            this.destroyLazyimages();
            this.destroyRellax();
            this.destroyAnalytics();
        },
        startAnalytics() {
            elementsTracking.init(this.$el);
        },
        destroyAnalytics() {
            elementsTracking.destroy(this.$el);
        },
        initRellax() {
            if (SizesUtils.winOffsetWidth() < 769) {
                return;
            }
            this._rellaxImages = [...this.$el.querySelectorAll('.rellax')];
            this._rellaxInstances = [];
            this._rellaxImages.forEach((image, index) => {
                this._rellaxInstances[index] = new Rellax(image, {
                    center: true,
                    speed: 0.5
                });
            });
        },
        destroyRellax() {
            if (this._rellaxInstances > 0) {
                this._rellaxInstances.forEach(instance => {
                    instance.destroy();
                });
            }
        },
        startLazyimages() {
            if (this._lazyimages) this.destroyInner();
            this._lazyimages = [...this.$el.querySelectorAll('.imageblock .lazyload')];
            this._lazyimages.forEach(image => {
                let imagePN = image.parentNode;
                imagePN.classList.add('lazycontainer');

                if (image.classList.contains('lazyloaded')) {
                    imagePN.classList.add('lazyloaded');
                    return;
                }

                image.data = image.data || {};
                image.data.onLoaded = () => {
                    imagePN.classList.add('lazyloaded');
                    if (!image.data || typeof image.data.onLoaded === 'undefined') return;
                    image.removeEventListener('lazyloaded', image.data.onLoaded);
                    delete image.data.onLoaded;
                };
                image.addEventListener('lazyloaded', image.data.onLoaded);
            });
        },
        destroyLazyimages() {
            if (!this._lazyimages) return;
            this._lazyimages.forEach(image => {
                if (!image.data || typeof image.data.onLoaded === 'undefined') return;
                image.removeEventListener('lazyloaded', image.data.onLoaded);
                delete image.data.onLoaded;
            });
            this._lazyimages = null;
        }
    }
};
